<div class="department-form">
    <div class="form-content">
        <form [formGroup]="departmentForm">
            <div class="section-title">{{ 'request_v2.department_form.department_color' | translate }}</div>

            <div class="visual-layout">
                <!-- App color selector -->
                <app-color-selector
                    [isVisible]="isDropdownVisible"
                    [selectedColor]="departmentForm.get('visual.color')?.value"
                    [colors]="departmentColors"
                    (colorSelect)="onColorSelect($event)"
                    (close)="isDropdownVisible = false"
                >
                </app-color-selector>

                <div class="color-container">
                    <div class="color-preview-container">
                        <div class="color-preview" [style.backgroundColor]="departmentForm.get('visual.color')?.value" (click)="toggleDropdownVisibility($event)"></div>
                    </div>
                    <div class="color-label">{{ 'request_v2.department_form.click_to_select' | translate }}</div>
                </div>
            </div>

            <div class="section-title department-name-title">{{ 'request_v2.department_form.department_name' | translate }}</div>

            <div class="name-form" formGroupName="name">
                <app-form-input-v2
                    #nameEnInput
                    label="{{ 'request_v2.department_form.english_name' | translate }}"
                    placeholder=""
                    [invalidPass]="departmentForm.get('name.en')?.invalid && departmentForm.get('name.en')?.touched"
                    [invalidText]="'common.errors.required' | translate"
                    formControlName="en"
                >
                </app-form-input-v2>

                <app-form-input-v2
                    #nameFrInput
                    label="{{ 'request_v2.department_form.french_name' | translate }}"
                    placeholder=""
                    [invalidPass]="departmentForm.get('name.fr')?.invalid && departmentForm.get('name.fr')?.touched"
                    [invalidText]="'common.errors.required' | translate"
                    formControlName="fr"
                >
                </app-form-input-v2>
            </div>

            <div class="section-title assignee-title">{{ 'request_v2.department_form.assignee' | translate }}</div>
            <app-assignee-selector
                [selectedAssigneeId]="departmentForm.get('settings.managers')?.value"
                [selectedAssigneeIds]="selectedAssigneeIds"
                [preloadedAdminData]="preloadedManagerObjects"
                (assigneeSelect)="onAssigneeSelect($event)"
                (assigneesSelect)="onAssigneesSelect($event)"
                [multiSelect]="true"
                [isInvalid]="departmentForm.get('settings.managers')?.invalid && (departmentForm.get('settings.managers')?.touched || departmentForm.get('settings.managers')?.dirty)"
                (close)="isAssigneeDropdownVisible = false"
            >
                <div
                    *ngIf="departmentForm.get('settings.managers')?.invalid && (departmentForm.get('settings.managers')?.touched || departmentForm.get('settings.managers')?.dirty)"
                    class="error-message"
                >
                    {{ 'common.errors.required' | translate }}
                </div>
            </app-assignee-selector>

            <div class="section-title">{{ 'request_v2.department_form.department_description' | translate }}</div>

            <div class="description-section" formGroupName="description">
                <div class="input-group">
                    <label>{{ 'request_v2.department_form.english_description' | translate }}</label>
                    <app-form-textarea formControlName="en" rows="3" wordLimit="80" (change)="updateWordCount($event, 'en')">
                        <div class="validation-error" *ngIf="departmentForm.get('description.en')?.invalid && departmentForm.get('description.en')?.touched" class="error-message">
                            {{ 'common.errors.required' | translate }}
                        </div>
                    </app-form-textarea>
                </div>

                <div class="input-group">
                    <label>{{ 'request_v2.department_form.french_description' | translate }}</label>
                    <app-form-textarea formControlName="fr" rows="3" wordLimit="80" (change)="updateWordCount($event, 'fr')">
                        <div class="validation-error" *ngIf="departmentForm.get('description.fr')?.invalid && departmentForm.get('description.fr')?.touched" class="error-message">
                            {{ 'common.errors.required' | translate }}
                        </div>
                    </app-form-textarea>
                </div>
            </div>
        </form>
    </div>
</div>
